// extracted by mini-css-extract-plugin
var _1 = "IntegrationDetailPreview-module__container--B_Y5p";
var _2 = "IntegrationDetailPreview-module__previewContentContainer--_kDdD";
export { _1 as "container", _2 as "previewContentContainer" }
